import React from 'react'
import Navbar from '../components/ui/Navbar/Navbar'
import Footer from '../components/ui/Footer/Footer'
function Dinning() {
  return (
    <>
       <Navbar/>
       <Footer/>
    </>
  )
}

export default Dinning